import * as React from "react";

import {AddressModalBase} from "../address-modal-base/address-modal-base";

/**
 * After creation
 */
export const AddressModalA = ({title=undefined, alterFields=v=>v, next}) => (
    AddressModalBase({
        title,
        fields: alterFields([
            {
                path: "name",
                label: "Name",
                // required: true,
            },
            {
                path: "name2",
                label: "Name 2",
            },
            {
                path: "address",
                label: "Address",
                required: true,
            },
            {
                path: "address2",
                label: "Address 2",
            },
        ]),
        next,
    })
);
